import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react';
import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { GenericDbCall } from '../components/LambdaApi'; // adjust path as needed
import { useClient } from '../context/ClientContext.tsx';

const SelectClientInner = () => {
  const { user } = useAuthenticator((context) => [context.user]);
  const location = useLocation();
  const userFromDB = location.state?.userFromDB;

  const [clientName, setClientName] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const { name, organization, setClientInfo } = useClient();

  //get the current client from the userFromDB passed in from PostLoginRedirect
  //we will not use this because it should not redirect if the client exists
  //the user should only be able to access this page if the client does not exist
  /*
  useEffect(() => {
    if (userFromDB?.ClientCode?.S) {
      setClientName(userFromDB.ClientCode.S);
    }
  }, [userFromDB]);
*/

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedClient = clientName.trim();

    if (!trimmedClient) {
      setError('Please enter a valid organization name.');
      return;
    }

    // Step 1: Check if client exists
    const getPayload = {
      table: "clients",
      operation: "get",
      key: {
        ClientCode: { S: trimmedClient }
      }
    };

    try {
      const clientCheck = await GenericDbCall(getPayload);
      //console.log("Client check result:", clientCheck);

      //check if the Client has not been set up yet
      //Users can only select an organization that has not yet been saved
      //if (!clientCheck || Object.keys(clientCheck).length === 0) {
      //setError('Organization not found. Please enter a valid existing organization.');
      if (!(!clientCheck || Object.keys(clientCheck).length === 0)) {
        setError('Organization already set up. Please contact your Organization admin or create a different Organization.');
        return;
      }

      // Step 2: Save the client
      const clientPayload = {
        table: "clients",
        operation: "put",
        item: {
          ClientCode: { S: trimmedClient },
          ClientDisplay: { S: trimmedClient },
          ExpirationDatetime: { S: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString() },  //today + 30 days, adding the appropriate number of milliseconds to the current time
          FirstLoginDatetime: { S: new Date().toISOString() },
          IsActive: { BOOL: true },
          StripeCustomerId: { S: "" }
        }
      };
      await GenericDbCall(clientPayload);

      // Step 3: Save user with selected client
      const payload = {
        table: "users",
        operation: "put",
        item: {
          //UserId: { S: user.userId },
          UserId: { S: user.signInDetails.loginId },
          //CognitoUserId: { S: user.cognitoUserId || "" },
          CognitoUserId: { S: user.userId },
          ClientCode: { S: trimmedClient },
          //Username: { S: user.username },
          Username: { S: user.signInDetails.loginId.split('@')[0] },
          Email: { S: user.signInDetails.loginId },
          FirstLoginDatetime: {
            S: userFromDB?.FirstLoginDatetime?.S || new Date().toISOString()
          },
          //LastLoginDatetime: { S: userFromDB?.LastLoginDatetime?.S || new Date().toISOString()},
          LastLoginDatetime: { S: new Date().toISOString() },
          IsActive: { BOOL: true },
          IsAdmin: { BOOL: true }
        }
      };

      await GenericDbCall(payload);
      setClientInfo({ name: user.signInDetails.loginId, organization: trimmedClient, isAdmin: true });
      navigate('/', { replace: true });

    } catch (err) {
      console.error('Error during client check or save:', err);
      setError('Something went wrong. Please try again.');
    }
  };

  return (
    <div style={{ maxWidth: '400px', margin: '2rem auto', padding: '1rem' }}>
      <h2>Create Your Organization</h2>
      <form onSubmit={handleSubmit}>
        <label htmlFor="clientName">Organization Name:</label>
        <input
          type="text"
          id="clientName"
          value={clientName}
          onChange={(e) => setClientName(e.target.value)}
          placeholder="e.g., ABC School"
          style={{ width: '100%', padding: '0.5rem', marginTop: '0.5rem' }}
        />
        {error && <p style={{ color: 'red' }}>{error}</p>}
        <button type="submit" style={{ marginTop: '1rem' }}>
          Save and Continue
        </button>
      </form>
    </div>
  );
};

const SelectClient = () => (
  <Authenticator>
    {() => <SelectClientInner />}
  </Authenticator>
);

export default SelectClient;